import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import ButtonBase from '@mui/material/ButtonBase';
import { Link } from 'react-router-dom';
import { NavItemLabel } from './side-nav-shared';
import { navRowSx } from './side-nav-utils';

const linkProps = ({ disabled, path, external }) => {
  if (disabled) return { disabled: true };
  if (!path) return {};
  return external
    ? { component: 'a', href: path, target: '_blank' }
    : { component: Link, to: path };
};

/** A nav item without children: a link to its page (or an external URL). */
export const SideNavLeaf = (props) => {
  const { depth, icon, disabled, offset, active, title, external, label, path } = props;

  return (
    <li>
      <ButtonBase
        sx={{ ...navRowSx({ active, depth, offset }), pr: '16px' }}
        {...linkProps({ disabled, path, external })}
        data-testid={`side-nav-leaf-${title}`}
      >
        <NavItemLabel depth={depth} icon={icon} active={active} disabled={disabled} title={title} />
        {label && (
          <Box component="span" sx={{ ml: 2 }}>
            {label}
          </Box>
        )}
      </ButtonBase>
    </li>
  );
};

SideNavLeaf.propTypes = {
  depth: PropTypes.number,
  icon: PropTypes.string,
  disabled: PropTypes.bool,
  offset: PropTypes.number,
  active: PropTypes.bool,
  title: PropTypes.string.isRequired,
  external: PropTypes.bool,
  label: PropTypes.node,
  path: PropTypes.string,
};
